document.querySelector('.sticky_atc').addEventListener('click', function(event) {
  const stickyAtc = event.currentTarget;
  stickyAtc.querySelector('[data-add-to-cart-text]').textContent = 'Ajout en cours';
  const addToCartButton = document.querySelector('.payment-buttons button[name="add"]');  
  if (addToCartButton) {
     stickyAtc.setAttribute('disabled', true);
     addToCartButton.click();
     setTimeout(() => {
        stickyAtc.querySelector('[data-add-to-cart-text]').textContent = 'Ajouté';
      }, 500);
     setTimeout(() => {
        stickyAtc.removeAttribute('disabled');
        stickyAtc.querySelector('[data-add-to-cart-text]').textContent = 'Ajouter au panier';
      }, 1500);
  } else {
    console.error('Add to Cart button not found');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyButton = document.querySelector(".sticky_atc");
  const form = document.querySelector(".payment-buttons");

  const isMobile = () => window.innerWidth <= 768;

  const toggleButtonVisibility = () => {
    if (!isMobile()) {
      stickyButton.classList.add("hide");
      return;
    }

    const formRect = form.getBoundingClientRect();
    const formInView = formRect.top < window.innerHeight && formRect.bottom > 0;

    if (formInView) {
      stickyButton.classList.remove("show");
      stickyButton.classList.add("hide");
    } else {
      stickyButton.classList.add("show");
      stickyButton.classList.remove("hide");
    }
  };

  // Hide the button initially
  stickyButton.classList.add("hide");

  // Attach event listeners for scroll and resize
  window.addEventListener("scroll", toggleButtonVisibility);
  window.addEventListener("resize", toggleButtonVisibility);
});



